module.exports = __webpack_public_path__ + "static/media/Item_Weapon_FNFal_C.32bd59cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_FNFal_C.png
// module id = 392
// module chunks = 0